import { call, put, takeLatest } from "redux-saga/effects";
import { fetchExam } from "../../../services/exam";
import { getExamStart, getExamSuccess, getExamFailure } from "../reducer";

export function* getExam({ payload }) {
  const response = yield call(fetchExam, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getExamSuccess(raw));
  } else {
    yield put(getExamFailure(message || raw.error));
  }
}

export default function* onGetExam() {
  yield takeLatest(getExamStart.type, getExam);
}
